module.exports = __webpack_public_path__ + "puwen_banner.png?3640688ee78be0d2716f8a1161dc46fd";